export const roundNumber = (number, decimalPlaces = 0) => {
    const power = Math.pow(10, decimalPlaces);

    return (Math.round(number * power + Number.EPSILON) / power).toFixed(decimalPlaces);
};
